export default {"src":"https://fishbrain.com/_next/static/media/florida.44f9ef4f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};